export default __webpack_public_path__ + "static/media/Creighton.d4caa420.jpg";